import { storageFactory } from 'storage-factory';

// Wrapper to prevent mobile Safari private mode `SecurityError` and to provide generic in-memory fallback.
export default storageFactory(() => sessionStorage);
